import { createReducer } from '../../app/common/util/reducerUtil';
import {
  DOWNLOAD_STATEMENT
} from './statementConstants';

const initialState = {};

export const downloadStatement = (state, payload) => {
  return {
    ...state,
    ...payload,
  }
};

export default createReducer(initialState, {
  [DOWNLOAD_STATEMENT]: downloadStatement,
});